module.exports = "/typo3conf/ext/grbundle/Resources/Public/Dist/7.jpg";